import Tooltip from "Components/Atoms/Tooltip";
import Typography from "Components/Atoms/Typography";
import React from "react";
import { ReservationSnippet } from "utils/types";
import { getGroupSizeColor } from "../groupSizeColor";
import ReservationTooltip from "./ReservationTooltip";

type GroupProps = {
  res: ReservationSnippet;
};

const Group = ({ res }: GroupProps) => {
  return (
    <Tooltip
      content={<ReservationTooltip res={res} />}
      className="group"
      style={{ background: getGroupSizeColor(res.guests) }}
    >
      <Typography variant="text-3" style={{ color: "#ffffff" }}>
        {res.guests}
      </Typography>
    </Tooltip>
  );
};

export default Group;
